import React from 'react';

import { withServerData } from '@xingternal/hops';

import GdprGerSvg from './GdprGerSvg';
import GdprEngSvg from './GdprEngSvg';

const svgStyle = { maxWidth: '120px' };

const GdprImage = ({ serverData: { language } }) =>
  language === 'de' ? (
    <GdprGerSvg styles={svgStyle} />
  ) : (
    <GdprEngSvg styles={svgStyle} />
  );

export default withServerData(GdprImage);
